import { render, staticRenderFns } from "./SpeedDialExten.vue?vue&type=template&id=358e0ff9"
import script from "./SpeedDialExten.vue?vue&type=script&lang=ts"
export * from "./SpeedDialExten.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports